import React from "react";
import { ConfirmDialog, LogoutIcon } from "@picklebet/ui";
import * as Session from "@/features/auth/services/session";
import { SignInModal } from "@/features/auth/components/SignInModal";
import { SignUpModal } from "@/features/auth/components/onboarding/SignUpModal";
import { BetStopModalSignup } from "@/features/auth/components/BetStopModalSignup";
import { BetStopModalLogout } from "@/features/auth/components/BetStopModalLogout";
import { ProfileCompletionModal } from "@/features/auth/components/ProfileCompletionModal";
import { CaptchaPuzzleModal } from "@/features/auth/components/CaptchaPuzzleModal";
import { MigrateToIOMLicenceModal } from "@/features/auth/components/MigrateToIOMLicenceModal";
import { EnableBiometricPrompt } from "@/features/auth/components/EnableBiometricPrompt";
import { Mw3dsFrame } from "@/features/wallet/components/Mw3dsFrame";
import { DepositModalContainer } from "@/features/wallet/components/deposit/components/deposit-modal/DepositModalContainer";
import { WithdrawModalContainer } from "@/features/wallet/components/withdraw/components/withdraw-modal/WithdrawModalContainer";
import { EndAllGameSessionsConfirmationModal } from "@/features/casino/components/EndAllGameSessionsConfirmationModal";
import { HelpCenter } from "@/features/help-center/components/HelpCenter";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { FullScreenSearchDialog } from "./FullScreenSearchDialog";
import { OpenInAppDialog } from "./OpenInAppDialog";

const AuthOverlays = () => {
  const modal = useShellStore((state) => state.modal);
  const setModal = useShellStore((state) => state.setModal);

  return (
    <>
      <ConfirmDialog
        icon={<LogoutIcon />}
        title={`Logout`}
        description={`Are you sure you want to log out?`}
        onClose={() => setModal(null)}
        isOpen={modal === "logout"}
        onConfirm={async () => await Session.signOut()}
      />
      <SignInModal />
      <SignUpModal />
      <BetStopModalSignup />
      <BetStopModalLogout />
      <ProfileCompletionModal />
      <CaptchaPuzzleModal />
      <MigrateToIOMLicenceModal />
      <EnableBiometricPrompt />
    </>
  );
};

const WalletOverlays = () => (
  <>
    <Mw3dsFrame />
    <DepositModalContainer />
    <WithdrawModalContainer />
  </>
);

const CasinoOverlays = () => <EndAllGameSessionsConfirmationModal />;

const LayoutOverlays = () => (
  <>
    <OpenInAppDialog />
    <FullScreenSearchDialog />
  </>
);

export const GlobalOverlays = () => (
  <>
    <HelpCenter />
    <AuthOverlays />
    <WalletOverlays />
    <CasinoOverlays />
    <LayoutOverlays />
  </>
);
